<template>
  <div class="my-2 d-flex">
    <div class="d-flex flex-row align-items-center px-4 py-2 font-weight-medium content-alert">
      <span  style="color: #0CB935">{{ data.length }}</span> <p style="margin: 0 6px"> {{ tipo }} adicionados</p>
    </div>

    <div>
      <v-btn
          class="mx-2 wc-btn-actions"
          color="primary"
          outlined
          @click="handleVisualizar"
      >
        Visualizar {{ tipo }}
        <v-icon class="ml-5px">mdi-eye-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: { type: Array, required: true },
  tipo: { type: String, required: true },
});

const emit = defineEmits(['visualizar']);

const handleVisualizar = () => {
  emit('visualizar', props.tipo);
};

</script>

<style>
.content-alert {
  width: 300px;
  background-color: #E6FBEB;
  border-radius: 8px
}
</style>
